module.exports = __webpack_public_path__ + "img/bg.65d88f41.webp";